export default __webpack_public_path__ + "static/media/link-to-register.06a456a3.svg";